webpackJsonp([166730631587841],{

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/download.56c76da2.jpg";

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABSCAYAAAAo7uilAAAACXBIWXMAAAsTAAALEwEAmpwYAAAGAGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDAgNzkuMTYwNDUxLCAyMDE3LzA1LzA2LTAxOjA4OjIxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoTWFjaW50b3NoKSIgeG1wOkNyZWF0ZURhdGU9IjIwMTctMDQtMjdUMTg6MjA6NDItMDM6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDE4LTA5LTEwVDAwOjE2OjUzLTAzOjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDE4LTA5LTEwVDAwOjE2OjUzLTAzOjAwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgcGhvdG9zaG9wOklDQ1Byb2ZpbGU9InNSR0IgSUVDNjE5NjYtMi4xIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjkyMDFjOTNmLTlhMDYtNDk2ZS1hN2JmLTA1MGIyNzNlZDJmMCIgeG1wTU06RG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjg3MGY5YjllLTY2YjItYzk0OC1hOGY3LWM3NTU5OTkzMmNkNCIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOmNjNjIyZDhmLTJiZjMtNGRmNC04Y2Q2LWMzODdkMGYyMjYzMCI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6Y2M2MjJkOGYtMmJmMy00ZGY0LThjZDYtYzM4N2QwZjIyNjMwIiBzdEV2dDp3aGVuPSIyMDE3LTA0LTI3VDE4OjIwOjQyLTAzOjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoTWFjaW50b3NoKSIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6OTIwMWM5M2YtOWEwNi00OTZlLWE3YmYtMDUwYjI3M2VkMmYwIiBzdEV2dDp3aGVuPSIyMDE4LTA5LTEwVDAwOjE2OjUzLTAzOjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoTWFjaW50b3NoKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7skkvUAAAFS0lEQVR4nO2d65WbOBSAv8zJ/1EqGDoYdRB1ENIBqWDZDtzBeiuI0gEdLNMB0wFTQXAF2R/CRwJjG9t6wIy/czhgIe69uugJEv5EelS/Zc72dOaaHdAAbb/V/e/Os22LRwIbTOL/eN4aYNvriM6nSHoyoOi3qVz3hs1hHcYpp5CA6PfyhMwK49x2pp2LRmESNM5BLaCBHOPoWxG9rG0ve6yv7m1ZJQqTADdBHcaBMoJ+iXFsx4qdmmEcNs6FBSb3pKDgMLfW+CkRwSgZ5oQWk5CloDh06iadOdMIhkW6Y4FGOhQMb3pDotZ/jGJoWM3Ci0+PYNgwdiQuRQVDY8qEtlxLzjAzbFMYoRnWjTKFEZ7IGA4gdEzlmmF9I2IqD4RgmK6aCOlyFeoYCiOjGTo0iiIdUlFiNIHTWYRWsDA0gRolxfurI+egsekufAgU2K5Dy8dxJJi0Ntiun7xVYI29OzcLWyEZNjM1twgqsY4sbzJp3eTcOJYX2DtSezFp3VTcUEI1tq7IvJm0XgRXZi7Jgh9RJaTA+iWfe1HNx2y959BgfXMWiee+lYNi+n1QqK3C/ysKxQX+0Vzg+QvYEs+J4017TkvNjLpTOAaUHpVvSePEUA4tHLnyWKTSiSQ8KVbEd9yxLfeUJrDvkvSxCM25CFegieMoNbGVoziNx3Rte5nd1MnMUZp7VNoRx5lTqJnxriFjwl8P/X4fsMO0gr549CjLB8qTnBZ4HcscO7PypOwjUPf7fB+wd+bXUYQ756n6/RP9kPuBYdavY1qzcmrnWAJ8xvaVdqx36l09ESYi6H0FnjE+rD5jnwo1EZRfwyumV/D1RJxT50LSYJypwBRz6ZxYCjvgB/AFY5/CTMz9gZnEuhTafi/2ATWmv7QJoOyaPmPD6SIqOJz7eUnn3ie5I5vP2CLSeFY05o3D0ZUEvjm/d9jJYMfoMIloGE6/fuGw7lSErQK6cUCou+bK/sN0I6FHcYoLZOcz5G8ImzOVI1s8nI4bnGz0u7rg2gqTk/fI20y5itrVn9qZbhF84/J1PI1znHzomtqZ74rUznxxjp+4vKMtvVnigdTObEe/8wuuzRkW7Zcj8UKinOPGdaaIawdw2OBsmWeH4LBfPJYVm+4Be0dlAgMqhiOaR87P2hWYLtWzE7YjzVRH4f5InTPh8OXdM8cXYhWYFvzbKHxDmhW9st+/gnFmMzoRmwr4dxT2CPwEfmPsqzEd458cLjr9RaJVEth+cgdmONn2ATK6KZay3/81ce55ImzPL9Ku35H9voZhznwk7SStEvjOvKdCO+Bv0i8n3N/oxg28Zmw8h3Nj52MUmAalda5vMVVCwfz6fUO4sbly5GbuiRr/78zhemf6YkM4Z26xNxmwrXnV73OPypZAFlC26vfVlNIYkxAyj7LPISb0C0+yM874q8F/UdcME9MQx6GCw6fxjUf5Wyamx7gfPCmBf/rjL+OIV6KA/ybCQ4+jJYeP5L7jb8jZYvq7R7tmAnsXS09K4YNOKYT7ZNc51MzsnUjHiMKzEYoPNg0b7gsETtFwYcmVWO9vAhi0Vgqu7D5qbNOfeTVpnQhuWLF308XvkIqZLfgxSkdA6cemVZLjqdqrufGOrJwMT0uk4b54v8G2HdKHUMVwfCt8CF0BmkB97sIRrH0KXigam95taAU6hIKFoImUzrEiEVJZAjQ2fXVshQ3vw6GCBJ8v2+Mqbll3tykj4Yf19hSOAWvt2Ocs4JOPexT3j5F6RXD/TK53Su4fcPZKxv3T4t5R3D967x3FB/o7hvsfhawcyf0vbIKheCd/rvQ/g/qArWzKeegAAAAASUVORK5CYII="

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  background-color: white;\n'], ['\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  background-color: white;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  width: 100vw;\n  height: 15vw;\n  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));\n'], ['\n  position: fixed;\n  top: 0;\n  z-index: 1;\n  width: 100vw;\n  height: 15vw;\n  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  left: 0;\n  top: 60vh;\n  width: 100vw;\n  height: 20vh;\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7));\n  z-index: 1;\n'], ['\n  position: absolute;\n  left: 0;\n  top: 60vh;\n  width: 100vw;\n  height: 20vh;\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7));\n  z-index: 1;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  background-color: white;\n  font-family: OpensansRegular;\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100vw;\n  background-color: white;\n  font-family: OpensansRegular;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  padding: 5vw;\n  color: gray;\n  background-color: white;\n  -webkit-columns: 3 200px;\n  -moz-columns: 3 200px;\n  columns: 3 200px;\n  -webkit-column-gap: 4em;\n  -moz-column-gap: 4em;\n  column-gap: 4em;\n\n  > h2 {\n    font-size: 1.7vw;\n    font-family: OpensansSemiboldItalic;\n    line-height: 1.6;\n  }\n\n  > em {\n    display: block;\n    font-family: OpensansRegular;\n    font-style: normal;\n    margin-top: 5vw;\n    // margin-bottom: 290px;\n    text-transform: uppercase;\n    font-size: 1.2vw;\n  }\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 1vw;\n    line-height: 2;\n    margin-top: 0.3vw;\n  }\n  > div {\n    column-break-before: always;\n  }\n  > p > b {\n    font-family: OpensansBold;\n  }\n  > p > a:link,\n  > p > a:hover,\n  > p > a:visited {\n    color: gray;\n    font-family: OpensansBold;\n    font-style: bold;\n    text-decoration: none;\n    // font-size: 100px;\n  }\n'], ['\n  position: relative;\n  padding: 5vw;\n  color: gray;\n  background-color: white;\n  -webkit-columns: 3 200px;\n  -moz-columns: 3 200px;\n  columns: 3 200px;\n  -webkit-column-gap: 4em;\n  -moz-column-gap: 4em;\n  column-gap: 4em;\n\n  > h2 {\n    font-size: 1.7vw;\n    font-family: OpensansSemiboldItalic;\n    line-height: 1.6;\n  }\n\n  > em {\n    display: block;\n    font-family: OpensansRegular;\n    font-style: normal;\n    margin-top: 5vw;\n    // margin-bottom: 290px;\n    text-transform: uppercase;\n    font-size: 1.2vw;\n  }\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 1vw;\n    line-height: 2;\n    margin-top: 0.3vw;\n  }\n  > div {\n    column-break-before: always;\n  }\n  > p > b {\n    font-family: OpensansBold;\n  }\n  > p > a:link,\n  > p > a:hover,\n  > p > a:visited {\n    color: gray;\n    font-family: OpensansBold;\n    font-style: bold;\n    text-decoration: none;\n    // font-size: 100px;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  position: relative;\n  padding: 7vw;\n  color: gray;\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 2.5vw;\n    line-height: 2;\n    margin-top: 0.3vw;\n  }\n  > div {\n    column-break-before: always;\n  }\n  > p > b {\n    font-family: OpensansBold;\n  }\n  > p > a:link,\n  > p > a:hover,\n  > p > a:visited {\n    color: gray;\n    font-family: OpensansBold;\n    font-style: bold;\n    text-decoration: none;\n    // font-size: 100px;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  position: relative;\n  padding: 7vw;\n  color: gray;\n\n  > p {\n    column-break-before: always;\n    font-family: OpensansRegular;\n    font-size: 2.5vw;\n    line-height: 2;\n    margin-top: 0.3vw;\n  }\n  > div {\n    column-break-before: always;\n  }\n  > p > b {\n    font-family: OpensansBold;\n  }\n  > p > a:link,\n  > p > a:hover,\n  > p > a:visited {\n    color: gray;\n    font-family: OpensansBold;\n    font-style: bold;\n    text-decoration: none;\n    // font-size: 100px;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  width: 100vw;\n  height: 70vh;\n  overflow: hidden;\n  background-position: no-repeat center center;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n\n  @media (max-width: 767px) {\n    height: 70vw;\n  }\n'], ['\n  width: 100vw;\n  height: 70vh;\n  overflow: hidden;\n  background-position: no-repeat center center;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-size: cover;\n\n  @media (max-width: 767px) {\n    height: 70vw;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 70vh;\n  left: 7.5vw;\n  font-family: OpensansItalic;\n  font-size: 2vw;\n  color: white;\n  z-index: 5;\n'], ['\n  position: absolute;\n  top: 70vh;\n  left: 7.5vw;\n  font-family: OpensansItalic;\n  font-size: 2vw;\n  color: white;\n  z-index: 5;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  opacity: 0.5;\n  @media (max-width: 767px) {\n    position: fixed;\n    left: 10vw;\n    bottom: 2vh;\n  }\n'], ['\n  opacity: 0.5;\n  @media (max-width: 767px) {\n    position: fixed;\n    left: 10vw;\n    bottom: 2vh;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(37);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _api = __webpack_require__(25);
	
	var _reactSlick = __webpack_require__(79);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _slide = __webpack_require__(82);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _download = __webpack_require__(163);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _instagramBlack = __webpack_require__(642);
	
	var _instagramBlack2 = _interopRequireDefault(_instagramBlack);
	
	var _facebookBlack = __webpack_require__(640);
	
	var _facebookBlack2 = _interopRequireDefault(_facebookBlack);
	
	var _reactResponsive = __webpack_require__(24);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Mobile = function Mobile(props) {
	  return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { maxWidth: 767 }));
	};
	var Desktop = function Desktop(props) {
	  return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { minWidth: 992 }));
	};
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var NavigationDimmer = _styledComponents2.default.div(_templateObject2);
	var HeroDimmer = _styledComponents2.default.div(_templateObject3);
	var ContentWrapper = _styledComponents2.default.div(_templateObject4);
	var ContentBlock = _styledComponents2.default.div(_templateObject5);
	
	var ContentBlockMobile = _styledComponents2.default.div(_templateObject6);
	
	var Image = _styledComponents2.default.div(_templateObject7);
	
	var Title = _styledComponents2.default.div(_templateObject8);
	
	var Social = _styledComponents2.default.div(_templateObject9);
	
	var settings = {
	  dots: false,
	  arrows: false,
	  fade: true,
	  infinite: true,
	  speed: 500,
	  autoplay: true,
	  lazyLoad: false,
	  swipe: false,
	  slidesToShow: 1,
	  slidesToScroll: 1
	};
	var content = function content(lang) {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    lang !== '?lang=en' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Endere\xE7o'
	        ),
	        _react2.default.createElement('br', null),
	        'Rua Alice 29, Laranjeiras ',
	        _react2.default.createElement('br', null),
	        'CEP 22241-020 Rio de Janeiro / RJ',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Entre em contato'
	        ),
	        _react2.default.createElement('br', null),
	        'E-mail:',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:escritorio@burlemarx.com.br' },
	          '\xA0escritorio@burlemarx.com.br'
	        ),
	        _react2.default.createElement('br', null),
	        'Tel.: 2558-3048 / 2558-3235',
	        _react2.default.createElement('br', null)
	      )
	    ),
	    lang === '?lang=en' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Address'
	        ),
	        _react2.default.createElement('br', null),
	        'Rua Alice 29, Laranjeiras ',
	        _react2.default.createElement('br', null),
	        'CEP 22241-020 Rio de Janeiro / RJ',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'Contact us'
	        ),
	        _react2.default.createElement('br', null),
	        'E-mail:',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:escritorio@burlemarx.com.br' },
	          '\xA0escritorio@burlemarx.com.br'
	        ),
	        _react2.default.createElement('br', null),
	        'Phone: 2558-3048 / 2558-3235',
	        _react2.default.createElement('br', null)
	      )
	    ),
	    _react2.default.createElement(
	      Social,
	      null,
	      _react2.default.createElement('img', {
	        src: _instagramBlack2.default,
	        style: {
	          width: '41px',
	          height: '41px',
	          marginTop: '20px'
	        },
	        onClick: function onClick() {
	          return window.open('https://www.instagram.com/escritorioburlemarx/', '_blank');
	        }
	      }),
	      _react2.default.createElement('img', {
	        src: _facebookBlack2.default,
	        style: {
	          width: '41px',
	          height: '41px',
	          marginLeft: '20px'
	        },
	        onClick: function onClick() {
	          return window.open('https://www.facebook.com/escritorioburlemarx/', '_blank');
	        }
	      })
	    )
	  );
	};
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Contact);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      page: { isLoading: true },
	      lang: 'pt'
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Contact.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.setState({ isLoading: true });
	    var lang = window.location.search;
	    (0, _api.getPageContents)('/contato', lang).then(function (page) {
	      _this2.setState({ page: page, isLoading: false, lang: lang });
	    });
	  };
	
	  Contact.prototype.render = function render() {
	    var _state$page = this.state.page,
	        slides_1 = _state$page.slides_1,
	        isLoading = _state$page.isLoading,
	        lang = _state$page.lang;
	
	    return _react2.default.createElement(
	      _gatsbyPluginPageTransitions2.default,
	      null,
	      _react2.default.createElement(
	        Wrapper,
	        null,
	        !isLoading && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(NavigationDimmer, null),
	          _react2.default.createElement(Image, {
	            style: {
	              backgroundImage: 'url(' + slides_1[0] + ')'
	            }
	          }),
	          _react2.default.createElement(
	            ContentWrapper,
	            null,
	            _react2.default.createElement(
	              Mobile,
	              null,
	              _react2.default.createElement(
	                ContentBlockMobile,
	                null,
	                content(this.state.lang)
	              )
	            ),
	            _react2.default.createElement(
	              Desktop,
	              null,
	              _react2.default.createElement(
	                ContentBlock,
	                null,
	                content(this.state.lang)
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contato-js-ef2bf373c26c770bcab3.js